import { render } from "./IndexInfo.vue?vue&type=template&id=ab5afa96"
import script from "./IndexInfo.vue?vue&type=script&lang=js"
export * from "./IndexInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__